// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_Geocoding_RPC_Sites_Types from "../Restaumatic.Geocoding.RPC.Sites.Types/index.js";
import * as Restaumatic_Geocoding_Types_GeocodeRequest from "../Restaumatic.Geocoding.Types.GeocodeRequest/index.js";
import * as Restaumatic_Site_RPC from "../Restaumatic.Site.RPC/index.js";
import * as Utils_DataLoading from "../Utils.DataLoading/index.js";
var sitesRPC = /* #__PURE__ */ Restaumatic_Site_RPC.sitesRPC(/* #__PURE__ */ Network_JsonRPC.encodeRequest(Restaumatic_Geocoding_Types_GeocodeRequest.encodeGeocodeRequest)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Geocoding_Types_GeocodeRequest.encodeGeocodeRequest)))(/* #__PURE__ */ Network_JsonRPC.decodeResponse(Restaumatic_Geocoding_RPC_Sites_Types.decodeGeocodeResponse))(Restaumatic_Geocoding_Types_GeocodeRequest.rPCMethodNameGeocodeReque);
var map = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var hoistErrors = function (v) {
    if (v instanceof Data_Either.Left) {
        return new Data_Either.Left(Utils_DataLoading.NetworkError.value);
    };
    if (v instanceof Data_Either.Right) {
        return new Data_Either.Right(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Services.Geocoding.Higgs (line 27, column 1 - line 27, column 60): " + [ v.constructor.name ]);
};
var geocode = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return function (country) {
                return function (streetAddress) {
                    return sitesRPC({
                        country: country,
                        streetAddress: streetAddress,
                        fromPS: new Data_Maybe.Just(fromPS),
                        restaurantId: restaurantId,
                        accountId: accountId
                    });
                };
            };
        };
    };
};
var convertCoords = function (v) {
    return {
        latitude: v.lat,
        longitude: v.lon
    };
};
var geocodeAddress = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return function (country) {
                return function (address) {
                    return map((function () {
                        var $21 = map1(function ($23) {
                            return (function (c) {
                                return {
                                    location: map2(convertCoords)(c)
                                };
                            })((function (v) {
                                return v.coordinates;
                            })(unwrap($23)));
                        });
                        return function ($22) {
                            return $21(hoistErrors($22));
                        };
                    })())(geocode(accountId)(restaurantId)(fromPS)(country)(address));
                };
            };
        };
    };
};
var higgsGeocoding = function (accountId) {
    return function (restaurantId) {
        return function (fromPS) {
            return {
                geocodeAddress: geocodeAddress(accountId)(restaurantId)(fromPS)
            };
        };
    };
};
export {
    higgsGeocoding
};
